/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'becomeacustomer/become-a-customer-success-step3': {
    width: 16,
    height: 16,
    viewBox: '0 0 83.27 44.3',
    data: '<g _fill="none" _stroke="#262422" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" data-name="Group 6422"><path pid="0" d="M74.92 40.57a3.54 3.54 0 01-3.47 2.83H20.24a3.54 3.54 0 01-3.47-4.25l7.38-35.42A3.54 3.54 0 0127.62.9h51.2a3.54 3.54 0 013.46 4.25z" data-name="Path 3283"/><path pid="1" d="M25.43 1.65l18.13 19.52a7.08 7.08 0 009.25.98L81.48 2.08" data-name="Path 3284"/><path pid="2" d="M.9 4.9h14" data-name="Line 146"/><path pid="3" d="M.9 14.9h11" data-name="Line 147"/><path pid="4" d="M.9 25.9h7" data-name="Line 148"/></g>'
  }
})
